/* eslint-disable no-useless-escape */
import { validateRut } from '../../../../domain/utils/utilitarios-frontend-coopeuch/rut';

const EMAIL_PATTERN = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

const personalDataUiModel = {
  executiveCode: {
    /* istanbul ignore next */
    isValid: () => true,
    value: '',
    errors: [],
  },
  executiveAttending: {
    /* istanbul ignore next */
    isValid: (el) => el !== '',
    isVisible: true,
    value: '',
    errors: [],
  },
  rut: {
    isValid: (elm) => validateRut(elm),
    containerCard: 'CardPersonValidation',
    isVisible: true,
    value: '',
    errors: [],
  },
  serialNumber: {
    isValid: (elm) => /^[a-zA-Z0-9]{9}$/.test(elm),
    containerCard: 'CardPersonValidation',
    isVisible: true,
    value: '',
    errors: [],
  },
  previredAuthorization: {
    isValid: (elm) => elm === true,
    containerCard: 'CardPersonValidation',
    isVisible: true,
    value: false,
    errors: [],
  },
  firstName: {
    isValid: (elm) => /^[a-zA-Z'ñÑáéíóúÁÉÍÓÚ ]{2,30}$/.test(elm),
    containerCard: 'CardPersonalData',
    isVisible: true,
    value: '',
    errors: [],
  },
  lastName: {
    isValid: (elm) => /^[a-zA-Z'ñÑáéíóúÁÉÍÓÚ ]{2,30}$/.test(elm),
    containerCard: 'CardPersonalData',
    isVisible: true,
    value: '',
    errors: [],
  },
  maternalLastName: {
    /* istanbul ignore next */
    isValid: (elm) => /^[a-zA-Z'ñÑáéíóúÁÉÍÓÚ ]{2,30}$/.test(elm),
    containerCard: 'CardPersonalData',
    isVisible: true,
    value: '',
    errors: [],
  },
  profession: {
    /* istanbul ignore next */
    isValid: (elm) => Object.values(elm).every((v) => v !== ''),
    containerCard: 'CardPersonalData',
    isVisible: true,
    value: {
      id: '',
      valor: '',
    },
    errors: [],
  },
  position: {
    /* istanbul ignore next */
    isValid: (elm) => Object.values(elm).every((v) => v !== ''),
    containerCard: 'CardPersonalData',
    isVisible: false,
    value: {
      codigo: '',
      descripcion: '',
    },
    errors: [],
  },
  workActivity: {
    /* istanbul ignore next */
    isValid: (elm) => Object.values(elm).every((v) => v !== ''),
    containerCard: 'CardPersonalData',
    isVisible: true,
    value: {
      id: '',
      valor: '',
    },
    errors: [],
  },
  countryNationality: {
    /* istanbul ignore next */
    isValid: (elm) => Object.values(elm).every((v) => v !== ''),
    containerCard: 'CardPersonalData',
    isVisible: false,
    value: {
      codigo: '',
      descripcion: '',
    },
    errors: [],
  },
  phone: {
    isValid: (elm) => /^9\d{8}$/.test(elm),
    containerCard: 'CardContactData',
    isVisible: true,
    value: '',
    complement: 'confirmationPhone',
    errors: [],
  },
  /* istanbul ignore next */
  confirmationPhone: {
    isValid: (elm) => /^\d{9}$/.test(elm),
    containerCard: 'CardContactData',
    isVisible: true,
    value: '',
    complement: 'phone',
    errors: [],
  },
  email: {
    isValid: (elm) => EMAIL_PATTERN.test(elm),
    containerCard: 'CardContactData',
    isVisible: true,
    value: '',
    errors: [],
  },
  address: {
    isValid: (elm) => Object.keys(elm).every((v) => elm[v] !== ''),
    containerCard: 'CardContactData',
    isVisible: true,
    isSelected:false,
    value: {
      street: '',
      numeration: '',
      commune: '',
      country: '',
      latitude: 0,
      longitude: 0,
    },
    anotherData: '',
    errors: [],
  },

  newAddress: {
    name: 'newAddress',
    isSelected: false,
    isValid: (elm) =>
      Object.keys(elm)
        // .filter((k) => k !== 'anotherData')
        .every((v) => elm[v] !== ''),
    value: {
      street: '',
      numeration: '',
      commune: '',
      country: '',
      latitude: '',
      longitude: '',
    },
    /* anotherValidation: {
      coverage: null,
    }, */
    schedule: null,
    anotherData: '',
    errors: [],
  },
  schedule: {
    containerCard: 'CardDirectionData',
    name: 'scheduling',
    isVisible:true,
    isValid: (elm, type = '') =>
      type === 'scheduling' ? Object.values(elm).every((v) => v !== '') : type !== '',
    value: {
      moduleId: '',
      regionId: '',
      communeId: '',
      day: '',
      hour: '',
    },
    type: '',
    errors: [],
  },
  preferredOffice: {
    isValid: (elm) => Object.values(elm).every((v) => v !== ''),
    isVisible: true, 
    value: {
      id: '',
      name: '',
      region: '',
      commune: '',
      address: '',
      officeHours: '',
    },
    errors: [],
  },
  taxDeclaration: {
    isValid: (elm) => Object.values(elm).some((v) => v === true),
    containerCard: '',
    isVisible: true,
    value: {
      chile: false,
      world: false,
      usa: false,
    },
    errors: [],
  }
};

export default personalDataUiModel;